//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import $ from 'zepto'
    import Vue from 'vue'
    import LeagueHeader from "../components/LeagueHeader"

    export default {
        ready () {
            $.init()
        },
      data () {
        return {
          leagueBasicInfo:{},
          teams:[],
          team_count:0,
          indexContentHeight: 0
        }
      },
        mounted(){
          // if (_czc) {_czc.push(['_trackEvent', '访问页面', '名称', '未开始联赛'])}
          this.id = this.$route.query.leagueId;
          this.hagkHttp(this.hagkApi.getLeagueBasic(this.id), {})
            .then((res) => {
              if (res.status == true) {
                  if ("inprogress"==res.result.event_status || "finished" == res.result.event_status) {
                    this.$router.replace({path:"/league_ongoing", query:{leagueId:this.id}})
                  }
                let result ={
                    title:res.result.name,
                    league_status : res.result.event_status,
                    league_start_time : res.result.start_date,
                    reg_start_time:res.result.reg_start_date,
                    reg_end_time:res.result.reg_end_date,
                    league_logo : res.result.logo

                }
                this.leagueBasicInfo = result;
                document.title = result.title;
              }
              this.$vux.loading.hide();
            }, (error) => {
              console.log(error)
              this.$vux.loading.hide()
            });

          this.hagkHttp(this.hagkApi.getLeagueTeams(this.id), {})
            .then((res) => {
              if (res.status == true) {
                this.team_count = res.result.total;
                this.teams = res.result.rows;
              }
              this.$vux.loading.hide();
            }, (error) => {
              console.log(error)
              this.$vux.loading.hide()
            });
          this.$nextTick(() => {
            var height = document.body.clientHeight;
            this.indexContentHeight = height-240;
          })
        },
        computed: {
            length () {
                return this.tasks.length
            }
        },
        methods: {
        },
        filters: {
          subfilter:function(value,sublength){
            if (!value) return ''
            value = value.toString()
            if(value.length > sublength){
              return value.substr(0,sublength)+"...";
            }
            return value;
          }
        },
        components: {LeagueHeader}
    }



// WEBPACK FOOTER //
// ./src/views/LeagueInfo.vue